import React from 'react';
import styles from './ProductCardSkeleton.module.scss';
import Box from '@/components/UI/box/Box';
import Divider from '@/components/UI/divider/Divider';
import Skeleton from '@/components/UI/skeleton/Skeleton';
const ProductCardSkeleton = () => {
  return <Box className={styles['skeleton-container']} data-sentry-element="Box" data-sentry-component="ProductCardSkeleton" data-sentry-source-file="ProductCardSkeleton.tsx">
      <Box className={styles['image-skeleton']} data-sentry-element="Box" data-sentry-source-file="ProductCardSkeleton.tsx">
        <Skeleton variant="rectangular" height={240} data-sentry-element="Skeleton" data-sentry-source-file="ProductCardSkeleton.tsx" />
      </Box>
      <Box className={styles['title-skeleton']} data-sentry-element="Box" data-sentry-source-file="ProductCardSkeleton.tsx">
        <Skeleton variant="text" width={50} height={20} data-sentry-element="Skeleton" data-sentry-source-file="ProductCardSkeleton.tsx" />
      </Box>
      <Box className={styles['title-skeleton']} data-sentry-element="Box" data-sentry-source-file="ProductCardSkeleton.tsx">
        <Skeleton variant="text" width={250} height={20} data-sentry-element="Skeleton" data-sentry-source-file="ProductCardSkeleton.tsx" />
      </Box>
      <Box className={styles['description-skeleton']} data-sentry-element="Box" data-sentry-source-file="ProductCardSkeleton.tsx">
        <Skeleton variant="text" width={180} height={20} data-sentry-element="Skeleton" data-sentry-source-file="ProductCardSkeleton.tsx" />
        <Divider orientation="vertical" data-sentry-element="Divider" data-sentry-source-file="ProductCardSkeleton.tsx" />
        <Skeleton variant="text" width={80} height={20} data-sentry-element="Skeleton" data-sentry-source-file="ProductCardSkeleton.tsx" />
      </Box>
      <Box className={styles['pricing-rating-section']} data-sentry-element="Box" data-sentry-source-file="ProductCardSkeleton.tsx">
        <Box className={styles['pricing-section']} data-sentry-element="Box" data-sentry-source-file="ProductCardSkeleton.tsx">
          <Skeleton variant="text" width={150} height={30} data-sentry-element="Skeleton" data-sentry-source-file="ProductCardSkeleton.tsx" />
        </Box>
      </Box>
    </Box>;
};
export default ProductCardSkeleton;